import {setCookie, hasCookie, getCookie, deleteCookie} from 'common-js/cooke-util';

// navbar mega menu start

const categoryMenu = document.querySelector('#js--categories');
const categoryMenuList = document.querySelector('#js--categories-menu');

const authorMenu = document.querySelector('#js--authors');
const authorMenuList = document.querySelector('#js--authors-menu');

const publisherMenu = document.querySelector('#js--publishers');
const publisherMenuList = document.querySelector('#js--publishers-menu');

const hscAndAdmissionMenu = document.querySelector("#js--hscAndAdmission");
const hscAndAdmissionMenuList = document.querySelector("#js--hscAndAdmission-menu");

if (categoryMenu && categoryMenuList) {
    categoryMenu.addEventListener('mouseover', (event) => showMenu(event, categoryMenu, categoryMenuList) );
}

if (authorMenu && authorMenuList) {
    authorMenu.addEventListener('mouseover', (event) => showMenu(event, authorMenu, authorMenuList));
}

if (publisherMenu && publisherMenuList) {
    publisherMenu.addEventListener('mouseover', (event) => showMenu(event, publisherMenu, publisherMenuList));
}

if (hscAndAdmissionMenu && hscAndAdmissionMenuList) {
    hscAndAdmissionMenu.addEventListener('mouseover', (event) => showMenu(event, hscAndAdmissionMenu, hscAndAdmissionMenuList));
}

function showMenu(event, menu, menuList) {
    menuList.classList.add('show');
    hideMenu(menu, menuList);

    if ( menu.querySelector('i').classList.contains('ion-chevron-down') ) {
        menu.querySelector('i').classList.remove('ion-chevron-down');
        menu.querySelector('i').classList.add('ion-chevron-up');
    } else {
        menu.querySelector('i').classList.remove('ion-chevron-up');
        menu.querySelector('i').classList.add('ion-chevron-down');
    }
}

function hideMenu(menu, menuList) {
    window.addEventListener('mouseover', (event) => removeMenuListener(event, menu , menuList) )
}

function removeMenuListener(event, menu, menuList) {
    if ( !menu.contains(event.target) && !menuList.contains(event.target) ) {
        menuList.classList.remove('show');
        window.removeEventListener('mouseover', removeMenuListener);

        // for removing and adding arrow icon
        menu.querySelector('i').classList.remove('ion-chevron-up');
        menu.querySelector('i').classList.add('ion-chevron-down');
    }
}

// navbar mega menu end

//Init Tooltip manually with custom data-type

    const headerWaypoint = new Waypoint({
        element: document.querySelector('.js--main-header'),
    
        handler: function(direction) {
            document.querySelector('.js--main-header').classList.toggle('shadow')
        },
    
        offset: function() {
            return -this.element.clientHeight
        }
    })


// Back Order Tooltip

$('[data-type="help"]').on('mouseover', function(event) {
    $(this).tooltip('show');
});

$('[data-type="help"]').on('mouseleave', function(event) {
    $(this).tooltip('hide');
});

// toggle button search
$(".js--search-filter-toggle").on('click', function() {
    const activeTab = $(this).attr("rel");
    $("#"+activeTab).fadeIn();
    $(this).parent().addClass("tab-slider-bg");
    $('.js--divider-toggle').hide()

    if($(this).attr("rel") == "tab2"){
        $('.tab-slider--tabs').addClass('slide');
    }else{
        $('.tab-slider--tabs').removeClass('slide');
    }
    
    $(".js--search-filter-toggle").removeClass("active");
    $(this).addClass("active");

    // set toggle valu hidden input and focus input field
    const filter = $(this).attr('data-value');
    $('#js--search-filter-input').val(filter);
    $('#js--search').trigger('focus');
});

